var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w-full text-left uppercase border-b border-blue-400 py-2 pl-2 pr-1 focus:outline-none hover:bg-gray-200",class:[
    _vm.isSelected ? 'item-selected' : '',
    _vm.isExcluded ? 'item-excluded' : '',
    _vm.sizeClass
  ],on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }